<template>
  <section class="intro container">
    <div class="intro-inner">
      <ul class="intro-wrapper clearfix">
        <li class="intro-item" ref="introText">
          <div class="title-box" ref="introTitle">
            <h2 class="do-hyeon-regular">Welcome to 'AXIS'</h2>
            <h3 class="sub-font">
              오직 예수, 오직 복음으로 하나님 나라의 'AXIS(축)'이 되는<br> 천호제일감리교회 젊은이부입니다!<br>
            </h3>
            <p class="deco-text">Only Jesus.</p>
          </div>
          <div class="content">

            <p class="bible-verse" ref="introBible">
              "그 작은 자가 천 명을 이루겠고 그 약한 자가 강국을 이룰 것이라<br>
              때가 되면 나 여호와가 속히 이루리라"<br>
              <span>- Isaiah 60:22 -</span>
            </p>
            <div class="button-container left-align" ref="introButtonContainer">
              <router-link to="/about">
                <button type="button">
                  소개 더보기
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 12-6-6m6 6-6 6m6-6H5"/></svg>
                </button>
              </router-link>
            </div>
          </div>
        </li>
        <li class="intro-item" ref="introImageItem">
          <div class="img-container">
            <img src="../../assets/resized/5116.jpg" alt="" :style="{ transform: `scale(${localIntroImageScale})` }" ref="introImage" id="introImage">
<!--            <img src="../../assets/axis/retreat/2025/winter/KakaoTalk_20250209_191020310_01.jpg" alt="" :style="{ transform: `scale(${localIntroImageScale})` }" ref="introImage" id="introImage">-->
<!--            <img src="../../assets/axis/retreat/2025/winter/KakaoTalk_20250209_191020310_02.jpg" alt="" :style="{ transform: `scale(${localIntroImageScale})` }" ref="introImage" id="introImage">-->
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Intro",
  props: {
    introImageScale: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      localIntroImageScale: this.introImageScale // props 값을 data로 복사
    };
  },

  mounted() {

    const ScrollObserverOptions = {
      root: null,
      threshold: .7
    };

    const scrollObserver = new IntersectionObserver(this.handleIntersect, ScrollObserverOptions);
    // 감시할 섹션 요소 추가
    scrollObserver.observe(this.$refs.introImage);

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',  // 뷰포트 하단에서 200px 지나야만 트리거
      threshold: 0  // 요소의 30%가 보일 때 트리거
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 요소가 보이면 isVisible을 true로 설정
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    observer.observe(this.$refs.introText);
    observer.observe(this.$refs.introImageItem);
  },

  methods: {
    handleIntersect(entries) {

      entries.forEach((entry) => {

        // intro 이미지
        if (entry.target.id === 'introImage' && entry.isIntersecting) {
          setTimeout(() => {
            this.localIntroImageScale = 1.05; // 배너 이미지 확대
          }, 100); // 이동 애니메이션 후 확대 애니메이션 시작 (0.5초 후)
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">

.intro {

  position: relative;

  .intro-inner {
    position: relative;

    padding-top: 200px;
    padding-bottom: 160px;

    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    .intro-wrapper {

      .intro-item {
        float: left;
        box-sizing: border-box;
        padding: 10px;
        text-align: left;

        &:first-child {
          width: 40%;
          opacity: 0;
          transform: translateX(-200px);
          transition: all .5s ease-out;

          &.visible {
            transform: translateX(0);
            opacity: 1;
          }
        }

        &:last-child {
          width: 60%;
          transform: translateX(20px);
          transition: all .5s ease-out;
          &.visible {
            opacity: 1;
            transform: translateX(0);
          }

          .img-container {
            overflow: hidden;
            border-radius: 5px;
            img {
              width: 100%;
              border-radius: 5px;
              transition: transform 2s ease;
            }
          }
        }

        .title-box {
          line-height: 1.5;
          position: relative;

          h2 {
            position: relative;
            z-index: 1;
          }

          .deco-text {
            position: absolute;
            top: -54px;
            left: 0;
            font-family: "Montserrat", sans-serif;
            font-optical-sizing: auto;
            font-weight: 900;
            color: #f3f3f3;
            font-size: 66px;
            z-index: 0;
          }
        }

        //.content {
        //  .button-container {
        //    justify-content: left;
        //  }
        //}
      }
    }

    .content {

      p {
        line-height: 1.5;

        &.bible-verse {
          color: #888;

          span {
            font-size: 15px;
            margin-top: 3px;
            display: inline-block;
            font-style: italic;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1512px) {

  .intro .intro-inner .intro-wrapper .intro-item .title-box .deco-text {
    font-size: 60px;
    top: -48px;
  }

  .intro .intro-inner {
    overflow: hidden;
  }

  .intro {
    .intro-inner {
      .intro-wrapper {
        box-sizing: border-box;
        padding: 15px;
      }
    }
  }
}

@media screen and (max-width: 1280px) {

  .intro .intro-inner .intro-wrapper .intro-item .title-box .deco-text {
    font-size: 50px;
    top: -40px;
  }
}

@media screen and (max-width: 900px) {
  .intro .intro-inner .intro-wrapper .intro-item .title-box .deco-text {
    font-size: 42px;
    top: -32px;
  }
}

@media screen and (max-width: 768px) {
  .intro .intro-inner {
    padding-top: 60px;
    padding-bottom: 40px;
    overflow: hidden;
  }

  .button-container {
    margin-top: 40px;
  }

  .intro .intro-inner .intro-wrapper .intro-item:first-child {
    width: 100%;
  }

  .intro .intro-inner .intro-wrapper .intro-item:last-child {
    margin-top: 30px;
    width: 100%;
  }

}

</style>